var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('cfg', {
    attrs: {
      "cid": "shopCart.destinatarioIndirizzo",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.addAddressLabels.destinatarioLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.destinatarioConfigs
    },
    model: {
      value: (_vm.destinatarioValue),
      callback: function($$v) {
        _vm.destinatarioValue = $$v
      },
      expression: "destinatarioValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.destinatarioValue),
      expression: "destinatarioValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "destinatarioId"
    },
    domProps: {
      "value": (_vm.destinatarioValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.destinatarioValue = $event.target.value
      }
    }
  })])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.addAddressLabels.indirizzoLbl) + _vm._s(_vm.indirizzoConfigs.mandatory))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.indirizzoConfigs
    },
    model: {
      value: (_vm.indirizzoValue),
      callback: function($$v) {
        _vm.indirizzoValue = $$v
      },
      expression: "indirizzoValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.indirizzoValue),
      expression: "indirizzoValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "indirizzoId"
    },
    domProps: {
      "value": (_vm.indirizzoValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.indirizzoValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.addAddressLabels.capLbl) + _vm._s(_vm.capConfigs.mandatory))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.capConfigs
    },
    model: {
      value: (_vm.capValue),
      callback: function($$v) {
        _vm.capValue = $$v
      },
      expression: "capValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.capValue),
      expression: "capValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "capId"
    },
    domProps: {
      "value": (_vm.capValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.capValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.addAddressLabels.localitaLbl) + _vm._s(_vm.localitaConfigs.mandatory))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.localitaConfigs
    },
    model: {
      value: (_vm.localitaValue),
      callback: function($$v) {
        _vm.localitaValue = $$v
      },
      expression: "localitaValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localitaValue),
      expression: "localitaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "localitaId"
    },
    domProps: {
      "value": (_vm.localitaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localitaValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.addAddressLabels.nazioneLbl) + _vm._s(_vm.nazioneConfigs.mandatory))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.nazioneConfigs
    },
    model: {
      value: (_vm.nazioneValue),
      callback: function($$v) {
        _vm.nazioneValue = $$v
      },
      expression: "nazioneValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('v-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "type",
      "menuStyle": {
        position: 'relative',
        'max-height': '150px',
        'height': '150px'
      },
      "options": _vm.nazioniList,
      "placeholder": _vm.$Jed.firstUpperTranslate('select') + ' ' + _vm.$Jed.translate('country')
    },
    on: {
      "input": function($event) {
        _vm.onNazioneDropdownChange(_vm.nazioneValue)
      }
    },
    model: {
      value: (_vm.nazioneValue),
      callback: function($$v) {
        _vm.nazioneValue = $$v
      },
      expression: "nazioneValue"
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.addAddressLabels.provinciaLbl) + _vm._s(_vm.provinciaConfigs.mandatory))])]), _vm._v(" "), (_vm.$Behaviors.allowFreeProvince) ? _c('input-w', {
    attrs: {
      "configs": _vm.provinciaConfigs
    },
    model: {
      value: (_vm.provinciaValue),
      callback: function($$v) {
        _vm.provinciaValue = $$v
      },
      expression: "provinciaValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provinciaValue),
      expression: "provinciaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "provinciaId"
    },
    domProps: {
      "value": (_vm.provinciaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.provinciaValue = $event.target.value
      }
    }
  })])]) : _c('input-w', {
    attrs: {
      "configs": _vm.provinciaConfigs
    },
    model: {
      value: (_vm.provinciaValue),
      callback: function($$v) {
        _vm.provinciaValue = $$v
      },
      expression: "provinciaValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('v-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "type",
      "menuStyle": {
        position: 'relative',
        'max-height': '150px',
        'height': '150px'
      },
      "options": _vm.provincesList,
      "placeholder": _vm.$Jed.firstUpperTranslate('select') + ' ' + _vm.$Jed.translate('province')
    },
    model: {
      value: (_vm.provinciaValue),
      callback: function($$v) {
        _vm.provinciaValue = $$v
      },
      expression: "provinciaValue"
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.addAddressLabels.regioneLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.regioneConfigs
    },
    model: {
      value: (_vm.regioneValue),
      callback: function($$v) {
        _vm.regioneValue = $$v
      },
      expression: "regioneValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regioneValue),
      expression: "regioneValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "regioneId"
    },
    domProps: {
      "value": (_vm.regioneValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.regioneValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "controls col-sm-5"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "width": "auto"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cancelClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.addAddressLabels.annullaBtnLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-1"
  }, [_vm._v(" \n                ")]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-5"
  }, [_c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "auto"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.confirmClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.addAddressLabels.confermaBtnLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-1"
  }, [_vm._v(" \n                ")])])])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(" ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1358516c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/shopcart/AddAddress.vue
// module id = 1694
// module chunks = 1